// src/App.jsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import Home from './pages/Home';
import Envios from './pages/Envios';
import Tasas from './pages/Tasas';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Registro from './pages/Registro';
import Security from './pages/Security';
import NotFound from './pages/NotFound';
import Login from './pages/Login';
import RecuperarContrasena from './pages/RecuperarContrasena';
import UserProfile from './pages/UserProfile';
import Admin from './pages/Admin';
import { AuthProvider, useAuth } from './context/AuthContext';

// ProtectedRoute para rutas seguras según autenticación y rol
function ProtectedRoute({ element, roles }) {
  const { user, userData } = useAuth();
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  if (roles && (!userData || !roles.includes(userData.role))) {
    return <Navigate to="/" replace />;
  }
  return element;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/envios" element={<Envios />} />
          <Route path="/tasas" element={<Tasas />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/registro" element={<Registro />} />
          <Route path="/login" element={<Login />} />
          <Route path="/recuperar-contrasena" element={<RecuperarContrasena />} />
          <Route path="/seguridad" element={<Security />} />
          <Route path="/profile" element={<ProtectedRoute element={<UserProfile />} />} />
          <Route path="/admin" element={<ProtectedRoute element={<Admin />} roles={["admin", "superadmin"]} />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
